import { Controller } from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        url: String,
        token: String,
    };

    // Not named "disconnect": that is a Stimulus lifecycle callback.
    disconnectCalendar(event) {
        event.preventDefault();

        showPreloader();

        fetch(this.urlValue, {
            method: 'POST',
            headers: { 'X-CSRF-Token': this.tokenValue },
        })
            .then((response) => response.json())
            .then((data) => {
                if (!data.status) {
                    hidePreloader();
                    addAlert('danger', translations['profile.An unknown error occurred.']);

                    return;
                }

                // The success confirmation is a flash set by the controller, so it
                // survives the reload that re-renders the page in its unsynced state.
                let reloaded = false;
                const reload = () => {
                    if (reloaded) {
                        return;
                    }

                    reloaded = true;
                    window.location.reload();
                };

                // Fired here rather than on click: the ticket asks for the event when
                // the agenda has been disconnected, so a failed attempt must not count.
                //
                // The reload waits on eventCallback: GTM dispatches the GA request
                // asynchronously, so reloading in the same tick aborts it and the event
                // never reaches GA. eventTimeout caps the wait inside GTM, and the
                // setTimeout below is the fallback for when GTM is absent or blocked
                // and eventCallback is therefore never called at all.
                dataLayer.push({
                    event: 'dataLayer.gaEvent',
                    gaEvent: {
                        action: 'agenda_sync_disconnect',
                        category: 'Account',
                        label: GA_EVENT_LABEL,
                        provider: '',
                        reason: '',
                    },
                    eventCallback: reload,
                    eventTimeout: 1000,
                });

                setTimeout(reload, 1000);
            })
            .catch(() => {
                hidePreloader();
                addAlert('danger', translations['profile.An unknown error occurred.']);
            });
    }
}
